import {
  DEFAULT_APPROVED_FILE_FORMATS,
  DEFAULT_MAX_FILE_SIZE,
  isValidUploadedFiles,
  IUploadErrorObject,
  uploadFilesToServer,
} from '@UI-Elements/FileUpload/fileUploadUtils';
import { FileWithPath } from 'react-dropzone';

const FILES_BUCKET = 'DocumentBatches/';

export const getMultiFilesProps = (
  onFilesUploaded: (_uploadedFiles: string[]) => void,
  setUploadError: (_err: IUploadErrorObject) => void,
  setLoading: (_loading: boolean) => void,
  batchAndType: string,
): any => ({
  onDrop: async (acceptedFiles: FileWithPath[]) => {
    const invalidFile = isValidUploadedFiles(acceptedFiles, DEFAULT_MAX_FILE_SIZE, DEFAULT_APPROVED_FILE_FORMATS, true);
    if (invalidFile !== null) {
      setUploadError(invalidFile);
      return;
    }
    setLoading(true);
    try {
      const uploadedFiles = await uploadFilesToServer(acceptedFiles, FILES_BUCKET + batchAndType, '');

      onFilesUploaded(uploadedFiles);

      setUploadError({ errorType: 'none', value: false });
    } catch (error) {
      setUploadError({ errorType: 'upload', value: true });
      console.error('Error uploading files:', error);
    }
    setLoading(false);
  },
});
